const HomeAnimation = (($) => {
  gsap.registerPlugin(ScrollTrigger);

  let _heroLogoElements;
  let _cards;

  const init = () => {
    _selectEls();
    _animate();
  };

  const _selectEls = () => {
    _heroLogoElements = $(".section-hero--home svg g.stagger");
    _cards = $(".card--value");
  };

  const _animate = () => {
    _heroLogoElements.addClass("show");

    $.each(_cards, (index, value) => {
      let $card = $(value);

      gsap.to($card, {
        scrollTrigger: {
          trigger: $card,
          // markers: true,
          toggleActions: "restart none none reset",
          toggleClass: "active",
          start: "0 90%",
        },
        ease: Linear.easeNone,
        duration: 1,
      });
    });
  };

  module.exports = {
    init: init,
  };
})(jQuery);
